import { parseAiBuilderAssistantMarkdownBlocks } from '../utils/aiBuilderAssistantMarkdown';
import { AiBuilderInlineMarkdown } from './AiBuilderInlineMarkdown';
export const AiBuilderAssistantMarkdownContent = ({
  content
}: {
  content: string;
}) => {
  const blocks = parseAiBuilderAssistantMarkdownBlocks(content);
  return <div className="flex min-w-0 flex-1 flex-col gap-3xs break-words text-body-lg-medium text-default" data-sentry-component="AiBuilderAssistantMarkdownContent" data-sentry-source-file="AiBuilderAssistantMarkdownContent.tsx">
      {blocks.map((block, blockIndex) => {
      if (block.type === 'list') {
        return <ul key={`list-${blockIndex}`} className="list-disc space-y-2xs pl-md">
              {block.items.map((item, itemIndex) => <li key={`item-${blockIndex}-${itemIndex}`}>
                  <AiBuilderInlineMarkdown text={item} />
                </li>)}
            </ul>;
      }
      if (block.type === 'heading') {
        return <p key={`heading-${blockIndex}`} className="font-bold">
              <AiBuilderInlineMarkdown text={block.text} />
            </p>;
      }
      if (block.type === 'quote') {
        return <blockquote key={`quote-${blockIndex}`} className="border-l-2 border-opacity-assistive pl-sm text-alternative">
              {block.lines.map((line, lineIndex) => <p key={`quote-${blockIndex}-${lineIndex}`}>
                  <AiBuilderInlineMarkdown text={line} />
                </p>)}
            </blockquote>;
      }
      if (block.type === 'spacer') {
        return <div key={`spacer-${blockIndex}`} aria-hidden="true" className="py-2xs" data-ai-assistant-markdown-spacer />;
      }
      return <p key={`paragraph-${blockIndex}`} className="whitespace-pre-line leading-relaxed">
            <AiBuilderInlineMarkdown text={block.text} />
          </p>;
    })}
    </div>;
};